import { Mono, Panel, SearchBox, GamePills } from "./ui";
import { ResultRow } from "./P2Resultados";

const D1_TYPES = [
  { key: "card", label: "Carta suelta" },
  { key: "sealed", label: "Sellado" },
  { key: "lot", label: "Lote · bulk, deck, colección" },
  { key: "accessory", label: "Accesorios", tag: "SELLADOS" },
];

// D1 · ≥1280 px · busca → ajusta → cola en una sola vista
export const D1Desktop = ({ games, game, onGame, type, onType, s, kb, onPick, onNewCard, searchRef, onScan, leftExtra, center, right }) => (
  <div className="relative rounded-[28px] border border-white/10 bg-[#0b0b0b] p-8 overflow-hidden" data-testid="d1-desktop">
    <div aria-hidden className="pointer-events-none absolute -top-32 -left-20 w-[620px] h-[360px] rounded-full blur-3xl" style={{ background: "radial-gradient(closest-side, rgba(255,68,56,.18), transparent)" }} />
    <div className="relative flex items-end justify-between gap-6 mb-5">
      <h1 className="font-extrabold tracking-[-.05em] leading-[.92] text-[56px] text-white">¿Qué vas a <span className="italic font-normal text-white/60">vender?</span></h1>
      <div className="flex gap-2 flex-wrap justify-end">
        {D1_TYPES.map((t) => (
          <button key={t.key} type="button" onClick={() => onType(t.key)} data-testid={`d1-type-${t.key}`}
            className={`h-11 px-4 rounded-full border text-[14px] ${type === t.key ? "text-white font-bold" : "text-white/70 border-white/12"}`}
            style={type === t.key ? { borderColor: "#FF4438", background: "rgba(255,68,56,.12)" } : { borderColor: "rgba(255,255,255,.12)" }}>
            {t.label}{t.tag && <span className="ml-2 sx-mono text-[8.5px] text-[#fbbf24]">{t.tag}</span>}
          </button>
        ))}
      </div>
    </div>
    <div className="relative mb-4"><GamePills games={games} value={game} onChange={onGame} /></div>
    <div className="relative grid grid-cols-[1.3fr_1fr_.8fr] gap-5 items-start">
      <div className="space-y-2 min-w-0" data-testid="d1-results">
        <SearchBox value={s.q} onChange={s.setQ} onClear={s.reset} onScan={onScan} inputRef={searchRef} testid="d1-search"
          hint={<span className="sx-mono text-[9px] text-white/45 border border-white/15 rounded-md px-1.5 py-1 shrink-0 hidden 2xl:inline">ESC · ↑↓ ENTER</span>} />
        {s.q.trim().length < 2 ? leftExtra : (
          <>
            {s.searching && !s.results.length && <Mono className="py-4">Buscando…</Mono>}
            <ul className="space-y-2">{s.results.map((c, i) => <ResultRow key={c.id} c={c} game={game} onPick={onPick} best={i === 0} compact kbActive={kb.activeIndex === i} kbVersion={kb.activeVersion} />)}</ul>
            {s.hasMore && <button type="button" onClick={s.loadMore} className="w-full text-[13px] font-bold text-white py-2" data-testid="d1-more">{s.loadingMore ? "Cargando…" : "Ver más ↓"}</button>}
            <div className="flex items-center justify-between gap-3 px-4 py-3 rounded-[14px] border border-dashed border-white/15 text-[12.5px]" data-testid="d1-not-found">
              <span className="text-white/55">¿No aparece? Prueba con el número o en inglés.</span>
              <button type="button" onClick={onNewCard} className="font-bold text-white shrink-0" data-testid="d1-new-card">Carta nueva · <span className="sx-mono text-[9px] text-[#fbbf24]">SE PUBLICA AL APROBAR</span></button>
            </div>
          </>
        )}
      </div>
      <div className="min-w-0" data-testid="d1-center">
        {center || <Panel className="p-6 text-center text-[13px] text-white/50" data-testid="d1-empty">Elige una carta de la lista · ↑↓ y ENTER</Panel>}
      </div>
      <div className="sticky top-24" data-testid="d1-queue">{right}</div>
    </div>
  </div>
);
